import { Fragment, useContext, useEffect, useState } from "react";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { GlobalContext } from "../../Context/GlobalContext";
import { OrderDetailItemBody } from "./OrderDetailItemBody";
import { useOrderClarificationModal } from "../../Context/OrderClarificationPopUpContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { OrderDetailClarification } from "./OrderClarification";
import { QuickOrder } from "../QuickOrder/QuickOrderMain";
import { OrderDetailSkeleton } from "../../Skeleton/OrderDetailSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { EmptyCart } from "../../Layout/Common/emptyCart";
import { useNavigate, Link, useParams } from "react-router-dom";
import { ConvertToFloat, isValidArray, scrollToTop } from "../../Layout/Common/common";
import { QuickOrderMain } from "../QuickOrder/quickOrdSidePopup/QuickOrderMain";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";

export const OrderDetails = () => {
  const [CartItem, setCartItem] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { clarificationItem } = useContext(GlobalContext);
  const history = useNavigate();
  const { isOrderClarification, showOrderClarification } = useOrderClarificationModal();
  useEffect(() => {
    if (globalcontext.CartItem) setCartItem(globalcontext.CartItem);
  }, [globalcontext.CartItem]);

  const handleCheckOutClick = (e) => {
    e.preventDefault();
    if (clarificationItem && isValidArray(clarificationItem)) {
      showOrderClarification();
    } else {
      history("/Checkout");
    }
  };

  return (
    <Fragment>
      <BreadCrumb data={[{ name: "My Cart", url: "" }]} />

      {CartItem && CartItem.cartItem ? (
        <Fragment>
          <section className="cart-section">
            <div className="container-fluid container-lg">
              {/* Cart Title */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="wesproduct-title cart-title">
                    <h1>My Cart</h1>
                    <div className="quickOrderBtn">
                      <div className="button-effect quickShopping">
                        <button
                          type="btn"
                          className="theme-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#quickOrder-popup"
                          aria-controls="offcanvasRight"
                        >
                          <span className="wes-shopping-bag"></span>Quick Order
                        </button>
                      </div>
                    </div>
                    {/*<Link to="/Home" className="d-none d-lg-block">*/}
                    {/*  <i className="fa-solid fa-chevron-left" /> Return to*/}
                    {/*  Product List*/}
                    {/*</Link>*/}
                  </div>
                </div>
              </div>
              {CartItem ? (
                <div className="row cart-products">
                  <div className="col-md-8 col-lg-8">
                    {/* Products */}
                    <OrderDetailClarification />
                    <OrderDetailItemBody cartItemList={CartItem.cartItem} totalItem={CartItem.totalItem} />
                    {/* Products */}
                  </div>
                  <div className="col-md-4 col-lg-4 mt-0 mt-lg-0">
                    <div className="order-summary-details">
                      <div className="order-prices">
                        <div className="order-prices-list">
                          <p>Sub Total</p>
                          <span>$ {CartItem && ConvertToFloat(CartItem.totalcost)}</span>
                        </div>
                        <div className="order-prices-list">
                          <p>Tax Amount</p>
                          <span>$ {CartItem && ConvertToFloat(CartItem.totaltax)}</span>
                        </div>
                        <div className="order-prices-list" style={{ display: "none" }}>
                          <p>Freight</p>
                          <span>TBA</span>
                        </div>
                      </div>
                      {/* Order Total */}
                      <div className="order-prices-list order-prices-total">
                        <p>Total</p>
                        <span>$ {CartItem && ConvertToFloat(CartItem.totalIncTax)}</span>
                      </div>
                      {/* Order Total */}
                    </div>
                    {/* Btn */}
                    <div className="subtotal-btn cartpage-btn">
                      <Link to="/home" className="btn btn-products btn-unavailable">
                        Continue Shopping
                      </Link>
                      <div className="button-effect popup-checkout-btn">
                        <a href="#" onClick={handleCheckOutClick} className="btn btn-products btn-addcart green-btn">
                          Checkout Now
                        </a>
                      </div>
                    </div>
                    {/* Btn */}
                  </div>
                </div>
              ) : (
                <OrderDetailSkeleton />
              )}
            </div>
          </section>

          <section className="subtotal-section d-none d-lg-block">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="cart-subtotal">
                    <p>Total - ${CartItem && ConvertToFloat(CartItem.totalIncTax)}</p>
                    <div className="button-effect popup-checkout-btn">
                      <a href="#" onClick={handleCheckOutClick} className="btn btn-products btn-addcart green-btn">
                        Checkout Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Fragment>
      ) : CartItem ? (
        <EmptyCart showHomeButton={false} showQuickOrderButton={false} showQuickOrderPopuButton={true} />
      ) : (
        <section className="cart-section">
          <div className="container-fluid container-lg">
            <OrderDetailSkeleton />
          </div>
        </section>
      )}
      <QuickOrderMain />
    </Fragment>
  );
};
